import { defineMessages } from 'react-intl';

export default defineMessages({
  contestReason: {
    id: 'court_manager_legal_proceedings_page.expert_report.contest_reason',
  },
  rejectionReasonLabel: {
    id:
      'court_manager_legal_proceedings_page.judgement_add.refusal_popin.reason',
  },
  contestDialogTitle: {
    id:
      'court_manager_legal_proceedings_page.expert_report.contest_dialog.title',
  },
  contestDialogValidate: {
    id:
      'court_manager_legal_proceedings_page.expert_report.contest_dialog.validate',
  },
  contestDialogCancel: {
    id:
      'court_manager_legal_proceedings_page.expert_report.contest_dialog.cancel',
  },
  courtManagerExpertReportDecision: {
    id: 'court_manager_legal_proceedings_page.expert_report.decision.status',
  },
  rejectionReason: {
    id: 'court_manager_legal_proceedings_page.civil_proceeding.reject_reason',
  },
  courtManagerExpertReportDecisionContestReason: {
    id:
      'court_manager_legal_proceedings_page.expert_report.decision.contest_reason',
  },
  decisionRecapTitle: {
    id: 'court_manager_legal_proceedings_page.expert_report.decision.title',
  },
  contested: {
    id: 'court_manager_legal_proceedings_page.expert_report.decision.contested',
  },
  confirmed: {
    id: 'court_manager_legal_proceedings_page.expert_report.decision.confirmed',
  },
  selectDecision: {
    id:
      'court_manager_legal_proceedings_page.expert_report.decision.decision_label',
  },
  makeDecision: {
    id:
      'court_manager_legal_proceedings_page.expert_report.decision.button_title',
  },
  decisionSelectLabel: {
    id:
      'court_manager_legal_proceedings_page.expert_report.decision.decision_label',
  },
  contest: {
    id: 'court_manager_legal_proceedings_page.expert_report.decision.contest',
  },
  confirm: {
    id: 'court_manager_legal_proceedings_page.expert_report.decision.confirm',
  },
  dismiss: {
    id: 'court_manager_legal_proceedings_page.expert_report.decision.dismiss',
  },
  dismissed: {
    id: 'court_manager_legal_proceedings_page.expert_report.decision.dismissed',
  },
});
